import styled, { css } from 'styled-components';
import { renderTextVariations } from '../utils/renderTextVariations.js';
import { wrapContentWithSeparator } from '../utils/wrapContentWithSeparator.js';

const SectionSubheading = styled.h3(({ type = 'default', bold, separator, stylish, theme: { olist: { components: { text: { sectionSubheading }, }, }, }, }) => css `
      ${renderTextVariations(sectionSubheading, type, bold, stylish)}
      ${separator && wrapContentWithSeparator()}
    `);

export { SectionSubheading as default };
